var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('svg-icon',{staticClass:"icon-lg",attrs:{"icon":"users-2"}}),_c('span',[_vm._v(_vm._s(_vm.participants)+" "+_vm._s(_vm.$tc('participant', _vm.participants)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }